(() => {
  const SELECTOR = '[data-mbb-professionals-partners]';

  class MbbPartners {

    constructor(section) {
      if (!section || section.dataset.initialized) return;

      this.section = section;
      this.viewport = section.querySelector('[data-partners-viewport]');
      this.track = section.querySelector('[data-partners-track]');
      this.slides = [...section.querySelectorAll('[data-partners-slide]')];
      this.prev = section.querySelector('[data-partners-prev]');
      this.next = section.querySelector('[data-partners-next]');
      this.pagination = section.querySelector('[data-partners-pagination]');

      if (!this.viewport || !this.track || this.slides.length < 2) return;

      this.index = 0;
      this.timer = null;

      this.autoplay = section.dataset.autoplay === 'true';
      this.speed = Number(section.dataset.speed) || 4000;

      this.bind();
      this.updateLayout();
      this.start();

      section.dataset.initialized = true;
    }

    visibleItems() {
      if (window.innerWidth <= 749)
        return Number(this.section.dataset.mobile) || 2;

      if (window.innerWidth <= 990)
        return Number(this.section.dataset.tablet) || 4;

      return Number(this.section.dataset.desktop) || 7;
    }

    updateLayout() {

      this.visible = this.visibleItems();

      this.section.style.setProperty('--items', this.visible);

      this.max = Math.max(0, this.slides.length - this.visible);

      this.index = Math.min(this.index, this.max);

      this.buildDots();

      requestAnimationFrame(() => this.update());
    }

    slideWidth() {

      if (this.slides.length < 2)
        return this.slides[0].offsetWidth;

      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    update() {

      this.track.style.transform =
        `translate3d(${-this.index * this.slideWidth()}px,0,0)`;

      this.prev?.toggleAttribute('disabled', this.index === 0);
      this.next?.toggleAttribute('disabled', this.index === this.max);

      this.pagination?.querySelectorAll('button').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
      });

    }

    go(index) {

      this.index = Math.max(0, Math.min(index, this.max));

      this.update();

      this.restart();

    }

    nextSlide() {

      this.go(this.index >= this.max ? 0 : this.index + 1);

    }

    prevSlide() {

      this.go(this.index <= 0 ? this.max : this.index - 1);

    }

    buildDots() {

      if (!this.pagination) return;

      this.pagination.innerHTML = '';

      for (let i = 0; i <= this.max; i++) {

        const btn = document.createElement('button');

        btn.type = 'button';

        btn.addEventListener('click', () => this.go(i));

        this.pagination.appendChild(btn);

      }

    }

    start() {

      if (!this.autoplay || this.max === 0) return;

      this.stop();

      this.timer = setInterval(() => this.nextSlide(), this.speed);

    }

    stop() {

      clearInterval(this.timer);

    }

    restart() {

      this.start();

    }

    bind() {

      this.next?.addEventListener('click', () => this.nextSlide());

      this.prev?.addEventListener('click', () => this.prevSlide());

      window.addEventListener('resize', () => {

        clearTimeout(this.resize);

        this.resize = setTimeout(() => this.updateLayout(), 150);

      });

      this.viewport.addEventListener('mouseenter', () => this.stop());

      this.viewport.addEventListener('mouseleave', () => this.start());

      this.viewport.addEventListener('keydown', e => {

        if (e.key === 'ArrowRight') this.nextSlide();

        if (e.key === 'ArrowLeft') this.prevSlide();

      });

      let startX = 0;

      this.viewport.addEventListener('pointerdown', e => {

        startX = e.clientX;

      });

      this.viewport.addEventListener('pointerup', e => {

        const diff = e.clientX - startX;

        if (Math.abs(diff) < 60) return;

        diff < 0 ? this.nextSlide() : this.prevSlide();

      });

    }

    destroy() {

      this.stop();

      delete this.section.dataset.initialized;

    }

  }

  function init(root = document) {

    root.querySelectorAll(SELECTOR).forEach(section => {

      if (!section.instance)

        section.instance = new MbbPartners(section);

    });

  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => init(), { once: true })
    : init();

  document.addEventListener('shopify:section:load', e => init(e.target));

  document.addEventListener('shopify:section:unload', e => {

    e.target.querySelectorAll(SELECTOR).forEach(section => {

      section.instance?.destroy();

      delete section.instance;

    });

  });

})();